
import { useTranslation } from "@/hooks/useTranslation"
import { Box, CircularProgress, Stack, Typography } from "@mui/material"
import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import MenuHeader from "./MenuHeader"
import RightGoogleMap from "./RightGoogleMap"
import SetUpLayout from "./SetUpLayout"

interface CommonSoilProps {
  titleHeader: string
  title: string
  subtitle: string
  link?: any
}

const CommonLoading = ({ titleHeader, title, subtitle, link }: CommonSoilProps) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const showPage = () => {
    setTimeout(() => {
      navigate(link)
    }, 3000)
  }

  useEffect(() => {
    showPage()
  })

  return (
    <SetUpLayout
      title={titleHeader}
      header={
        <MenuHeader />
      }
      rightLayout={<RightGoogleMap style={{
        width: { xs: '488px' },
      }}
      />}
    >
      <Stack alignItems="center" flexGrow="1">
        <Box sx={{ mt: "52px" }}>
          <Stack alignItems="center">
            <Typography sx={{ color: "#5C5C5C", fontSize: "16px", fontWeight: "500", cursor: "pointer" }}>{title}</Typography>
          </Stack>
          <Stack alignItems="center">
            <Typography sx={{ color: "#181818", fontSize: "18px" }}>{subtitle}</Typography>
          </Stack>
        </Box>

        <Box sx={{ mt: "186px" }}>
          <Stack alignItems="center">
            <CircularProgress />
          </Stack>
          <Stack alignItems="center">
            <Typography sx={{ color: "#004744", fontSize: "14px", fontWeight: "500", letterSpacing: "0.02em", mt: "28px" }}>{t('commonStatusProcessingData')}</Typography>
          </Stack>
          <Typography sx={{ color: "#181818", lineHeight: "1.6", mt: "7px" }}>{t('commonStatusPleaseDoNotClose')}</Typography>
        </Box>
      </Stack>
    </SetUpLayout>
  )
}

export default CommonLoading